import { LineItem } from 'types';

export const calcBaselinePrice = (item: LineItem): number => {
  const { price, extended_quantity: extendedQuantity, quantity } = item;
  let defaultedPrice;
  let defaultedExtendedQuantity;
  let defaultedQuantity;

  if (typeof price === 'string') {
    defaultedPrice = parseFloat(price) || 0.0;
  } else {
    defaultedPrice = price || 0.0;
  }

  if (typeof extendedQuantity === 'string') {
    defaultedExtendedQuantity = parseFloat(extendedQuantity) || 0.0;
  } else {
    defaultedExtendedQuantity = extendedQuantity || 0.0;
  }

  if (typeof quantity === 'string') {
    defaultedQuantity = parseFloat(quantity) || 1.0;
  } else {
    defaultedQuantity = quantity || 1.0;
  }

  return defaultedPrice * (defaultedExtendedQuantity / defaultedQuantity);
};
